import { AxiosInstance } from 'axios';
import { TopicInsideRepository } from '@/model/repository/manager/childcare-document/TopicInsideRepository';

export const topicInsideRepositoryImpl =
  (Repository: AxiosInstance) =>
  (resource: string): TopicInsideRepository => ({
    getUnreadCount(payload) {
      return Repository.get(`${resource}/unread/count`, { params: payload });
    },
  });
